import { Directive, ElementRef, Input, Renderer, OnInit, Renderer2 } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[draggable]'
})
export class DraggableDirective implements OnInit {

    // tslint:disable-next-line:no-input-rename
    @Input('stop') stop: (event, ui) => void;
    // tslint:disable-next-line:no-input-rename
    @Input('start') start: (event, ui) => void;
    // tslint:disable-next-line:no-input-rename
    @Input('drag') drag: (event, ui) => void;

    @Input('stack') stackSelector: string = '.k-draggable';

    @Input('appendTo') appendTo: string = 'body';

    @Input() helper: any = 'clone';

    constructor(private el: ElementRef,
        private renderer2: Renderer2) {

    }

    ngOnInit(): void {
        let self = this;
        self.renderer2.addClass(this.el.nativeElement, 'k-draggable');
        $(this.el.nativeElement).draggable({
            helper: this.helper,
            revert: "invalid",
            stack: this.stackSelector,
            appendTo: this.appendTo,
            drag: function (event, ui) {
                if (self.drag) {
                    self.drag(event, ui);
                }
            },
            start: function (event, ui) {
                if (self.start) {
                    self.start(event, ui);
                }
            },
            stop: function (event, ui) {
                if (self.stop) {
                    self.stop(event, ui);
                }
            },
        });
    }


}
